import React from 'react';
import { Typography } from '@tvg/fuse/typography';

import styles from './PrfInfo.module.css';

function PrfInfo({ prfValue, weeeEligibilityInd }: { prfValue?: string; weeeEligibilityInd?: boolean }): JSX.Element {
  return weeeEligibilityInd && prfValue ? (
    <Typography size="m1" tag="p" type="paragraph" data-testid="prf-info-wrapper">
      {`Included in this price is a contribution to the recycling cost of ${prfValue}`}
    </Typography>
  ) : (
    <div className={styles.marginContainer} />
  );
}

export default PrfInfo;
